import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Registration from './container/login/Student/Registration';
import Login from './container/login/Student/Login';
import ForgotPassword from './container/login/Student/ForgotPassword';
import OtpVerification from './container/login/Student/OtpVerification';
import LoginOtpVerification from './container/login/Student/LoginOtpVerification';
import ResetPassword from './container/login/Student/ResetPassword';
import Success from './container/login/Student/Success';
import Courses from './container/courses/Courses';
import Header from './container/header/Header';
import Home from './container/home/Home';
// import CourseDetails from './container/courses/CourseDetails';
import CourseDetailsPage from './container/courses/CourseDetailsPage';
import CoursesVideos from './container/courses/CoursesVideos';
import MasterclassVideo from './container/courses/MasterclassVideo';
import StudentDashboard from './container/studentDashboard/StudentDashboard';
import PaymentScreen from './container/courses/PaymentScreen';
import CourseCompletion from './container/courses/CourseCompletion';
import { ToastContainer } from 'react-toastify';
import PaymentFailed from './container/courses/PaymentFailure';
import PageNotFound from './container/courses/PageNotFound';
import { useEffect, useRef } from 'react';
import api from './container/helper/Api';
import ProtectedRoute from './container/helper/protectedRoute';
import ComingSoon from './container/courses/comingSoon';
import Webinars from './container/courses/Webinars';
import WebinarDetailsPage from './container/courses/WebinarDetailsPage';
import HostMeeting from './container/courses/HostMeeting';
import AffiliateLogin from './container/login/Affiliate/Login';
import AffiliateRegistration from './container/login/Affiliate/Registrations';
import AffiliateForgotPassword from './container/login/Affiliate/ForgotPassword';
import AffiliateOtpVerification from './container/login/Affiliate/OtpVerification';
import AffiliateResetPassword from './container/login/Affiliate/ResetPassword';
import AffiliateSuccess from './container/login/Affiliate/Success';
import AffiliateDashboard from './container/AffiliateDashboard/AffiliateDashboard';
import Affiliate from './container/courses/affiliate/Affiliate';
import { useSelector } from 'react-redux';
import StudentSupportMessage from './container/studentDashboard/StudentSupportMessages';
// Create a context for chat functionality
import { createContext, useContext } from 'react';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;
  const token = localStorage.getItem("token");
  const { isLoggedIn } = useSelector(state => state.user);
  
  // Add ref to control chat
  const chatRef = useRef();

  // Function to open chat - this will be passed via context
  const openChat = () => {
    if (chatRef.current && chatRef.current.openChat) {
      chatRef.current.openChat();
    }
  };

  // Provide chat functionality via context
  const chatContextValue = {
    openChat
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // fetching profile from api
        const { data, status } = await api.getProfile();

        //parcing and checking value of status is true or false if false re-diarects to login page
        if (data?.data?.status !== true) {

          // clearing local storage
          localStorage.clear()

          // navigates to login
          navigate("/login")
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };


    // Set up an interval to fetch the profile every 15 seconds
    const interval = setInterval(() => {
      fetchProfile();
    }, 15000);

    // clear interval
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {

    if ((pathName === "/login" || pathName === "/affiliate/login") && isLoggedIn) {
      // navigate("/")
    }
  }, [pathName, isLoggedIn])



  return (
    <ChatContext.Provider value={chatContextValue}>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        theme='dark'
      >
      </ToastContainer>
      {/* <LocationBasedHeader/> */}
      {location.pathname !== "/login" &&
        location.pathname !== "/registration" &&
        location.pathname !== "/forgotPassword" &&
        location.pathname !== "/loginOtpVerification" &&
        location.pathname !== "/otpVerification" &&
        location.pathname !== "/success" &&
        location.pathname !== "/affiliate/affiliate" &&
        location.pathname !== "/affiliate/forgotPassword" &&
        location.pathname !== "/affiliate/login" &&
        location.pathname !== "/affiliate/otpVerification" &&
        location.pathname !== "/affiliate/registration" &&
        location.pathname !== "/resetPassword" && <Header />}

        
      <Routes>

        <Route path='/' element={<Courses />} />
        <Route path='/login' element={<Login />} />
        <Route path='/registration' element={<Registration />} />
        <Route path='/forgotPassword' element={<ForgotPassword />} />
        <Route path='/otpVerification' element={<OtpVerification />} />
        <Route path='/loginOtpVerification' element={<LoginOtpVerification />} />
        <Route path='/resetPassword' element={<ResetPassword />} />

        <Route path='/affiliate/affiliate' element={<Affiliate />} />
        <Route path='/affiliate/login' element={<AffiliateLogin />} />
        <Route path='/affiliate/registration' element={<AffiliateRegistration />} />
        <Route path='/affiliate/forgotPassword' element={<AffiliateForgotPassword />} />
        <Route path='/affiliate/otpVerification' element={<AffiliateOtpVerification />} />
        <Route path='/affiliate/resetPassword' element={<AffiliateResetPassword />} />
        <Route path='/affiliate/success' element={<AffiliateSuccess />} />


        <Route path='/affiliate/affiliateDashboard' element={<AffiliateDashboard />} />


        <Route path='/success' element={<Success />} />
        <Route path='/pageNotFound' element={<PageNotFound />} />
        <Route path="/courses/Courses" element={<Courses />} />
        <Route path="/" element={<Navigate to="/courses/Courses" replace />} />
        {/* <Route path='/courses/Courses/CourseDetails/:id' element={<CourseDetails />} /> */}
        <Route path='/courses/Courses' element={<Courses />} />
        <Route path='/courses/Courses/CourseDetails/Masterclass/:id' element={<ProtectedRoute><MasterclassVideo /></ProtectedRoute>} />
        <Route path='/courses/Courses/CourseDetails/:id' element={<CourseDetailsPage />} />
        <Route path='/webinar/webinar' element={<Webinars />} />
        <Route path='/webinar/webinar/webinardetails/:id' element={<WebinarDetailsPage />} />
        <Route path='/courses/Courses/CourseDetails/PaymentScreen/:id' element={<ProtectedRoute><PaymentScreen /></ProtectedRoute>} />
        <Route path='/courses/Courses/CourseDetails/PaymentFailed/:id' element={<PaymentFailed />} />
        <Route path='/courses/Courses/CourseDetails/CoursesVideos/:id' element={<ProtectedRoute><CoursesVideos /></ProtectedRoute>} />
        <Route path='/courses/join/:id' element={<ProtectedRoute><HostMeeting /></ProtectedRoute>} />
        <Route path='/home/Home' element={<ComingSoon />} />
        <Route path='/studentDashboard/StudentDashboard' element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
        <Route path='/profile/Profile' element={<Home />} />
        <Route path='/courses/Courses/CourseDetails/CoursesVideos/CourseCompletion/:id/:studentId' element={<CourseCompletion />} />
        <Route path="*" element={<ComingSoon />} />
      </Routes>

      {/* Pass ref to StudentSupportMessage */}
      <StudentSupportMessage ref={chatRef} />
    </ChatContext.Provider>
  );
}